import API from '@js/api'

const types = {
  SET_USER_INFO: 'SET_USER_INFO',
  LOGOUT: 'LOGOUT',
}

const state = {
  userInfo: {},
}

const getters = {
  userInfo (state) {
    return state.userInfo
  },

  userId (state) {
    return state.userInfo?.id
  },

  isLogged (state) {
    return state.userInfo && Object.keys(state.userInfo).length
  },
}

const actions = {
  // 获取用户信息
  checkUserInfo ({ commit, getters }) {
    return new Promise(async (resolve, reject) => {
      try {
        if (getters.isLogged) {
          resolve()
          return
        }
        const userInfo = await API.account.userInfo()
        commit(types.SET_USER_INFO, userInfo)
        resolve()
      } catch (err) {
        console.warn(err)
        reject(err)
      }
    })
  },

  // 获取用户信息
  getUserInfo ({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const userInfo = await API.account.userInfo()
        commit(types.SET_USER_INFO, userInfo)
        resolve()
      } catch (err) {
        console.warn(err)
        reject(err)
      }
    })
  },

  // 获取用户信息
  logout ({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        await API.account.logout()
        commit(types.LOGOUT)
        resolve()
      } catch (err) {
        console.warn(err)
        reject(err)
      }
    })
  },

  // 设置用户信息
  setUserInfo ({ commit, state }, userInfo) {
    commit(types.SET_USER_INFO, userInfo)
  },
}

const mutations = {
  // 设置用户信息
  [types.SET_USER_INFO] (state, userInfo = {}) {
    state.userInfo = userInfo

    if (userInfo && userInfo.id) {
      localStorage.setItem('uid', userInfo.id)
    }

    if (userInfo && userInfo.token) {
      localStorage.setItem('token', userInfo.token)
    }

    if (!userInfo || !Object.keys(userInfo).length) {
      localStorage.removeItem('token')
    }
  },

  // 设置用户信息
  [types.LOGOUT] (state) {
    state.userInfo = {}
    localStorage.removeItem('token')
  },
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}
